import router from '@/router';
import { useGnbMenu } from '@/composables/useGnbMenu';
import { datadogRum } from '@datadog/browser-rum';
import { useAuthStore } from '@/stores/auth';
import { useLocalStorageStore } from '@/stores/localStorage';

export default function useSessionHanlder() {
  const useSignout = () => {
    const authStore = useAuthStore();
    authStore.reset();
    useLocalStorageStore().removeLocalStorage();

    datadogRum.clearUser();
  };

  const success = (
    { sessionToken, clientInfo, centerInfo, tos }: vuex.sessionHandler,
    loginType: 'normal' | 'naver' | 'kakao' | 'sso' | 'external'
  ) => {
    const { getMenu } = useGnbMenu();
    const authStore = useAuthStore();
    authStore.updateSessionToken(sessionToken);
    authStore.updateClientInfo(clientInfo as any);
    authStore.updateCenterInfo(centerInfo as any);
    authStore.updateMarketingAgreement(tos?.marketing ?? null);
    useLocalStorageStore().saveToLocalStorage();

    datadogRum.setUser({
      loginType: loginType,
      name: clientInfo?.name ?? 'user',
      center: centerInfo?.name ?? '',
      version: __APP_VERSION__,
    });

    const firstOutboundURL = getMenu.value[0].children![0] ? getMenu.value[0].children![0].link : '/';

    const nextURL = sessionStorage.getItem('redirectURL');
    const redirectURL = nextURL === '/outbound/complete' ? firstOutboundURL : nextURL;

    return router.replace(redirectURL ?? '/');
  };

  const failed = () => {
    useSignout();
    return router.push('/');
  };

  return {
    success,
    failed,
    useSignout,
  };
}
